import { LitElement, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import '../icon';
import { IconEnums } from '../icon';
import { AtlChatMessageProps } from './messaging.props';

import * as TagNames from './messaging.tagnames';
import { AtlIconTemplate } from '../icon/icon.component';

@customElement(TagNames.ChatMessage)
export class AtlChatMessage extends LitElement implements AtlChatMessageProps {
   declare sent?: boolean;
   declare hideAvatar?: boolean;
   declare pictureUrl?: string;
   declare date?: string;
   declare name?: string;
   declare _hasAvatarSlot?: boolean;

   static properties = {
      sent: { type: Boolean },
      hideAvatar: { attribute: 'hide-avatar', type: Boolean },
      pictureUrl: { attribute: 'picture-url', type: String },
      date: { type: String },
      name: { type: String },
      _hasAvatarSlot: { type: Boolean, state: true },
   };

   constructor() {
      super();
   }

   static styles = [...getGlobalStyleSheets()];

   handleSlotchange() {
      const slot = this.shadowRoot?.querySelector(
         'slot[name="avatarSlot"]'
      ) as HTMLSlotElement;
      this._hasAvatarSlot = slot.assignedElements({ flatten: true }).length > 0;
   }

   renderMessageAvatar() {
      if (!this.hideAvatar) {
         return html`
            <div class="contact-avatar">
               <slot name="avatarSlot" @slotchange=${this.handleSlotchange}>
                  ${this.pictureUrl
                     ? html`<img
                          src=${this.pictureUrl}
                          alt="avatar"
                          class="contact-avatar"
                       />`
                     : AtlIconTemplate({
                          iconSource: IconEnums.IconSource.FontAwesome,
                          iconName: 'user',
                          iconSize: IconEnums.IconSizes.Medium,
                          iconClassNames: 'contact-avatar',
                       })}
               </slot>
            </div>
         `;
      }
      return nothing;
   }

   render() {
      const classNames = ['messaging-chat-message'];
      if (this.sent) {
         classNames.push('sent');
      }

      return html`
         <div class=${classNames.join(' ')}>
            <div class="messaging-chat-message-avatar">
               ${this.renderMessageAvatar()}
            </div>
            <div class="messaging-chat-message-body">
               <div class="card">
                  <div class="card-header">
                     ${this.name
                        ? html`<span class="card-label">${this.name}</span>`
                        : nothing}
                     ${this.date
                        ? html`<span class="card-date">${this.date}</span>`
                        : nothing}
                  </div>
                  <div class="card-body">
                     <slot></slot>
                  </div>
               </div>
            </div>
         </div>
      `;
   }
}
